import NotFound from "./NotFound";
import NavbarScreen from "./NavBar/NavbarScreen";
import FromUpdateRegisterSpecial from "./FromUpdateRegisterSpecial";
import FromUpdateRegisterNormal from "./FromUpdateRegisterNormal";

import FooterConfig from "./Footer/FooterScreen";
import SupportScreen from "./Support/SupportScreen";
import LoadingConfig from "./Loading/index";

export {
  NotFound,
  NavbarScreen,
  FooterConfig,
  SupportScreen,
  FromUpdateRegisterNormal,
  FromUpdateRegisterSpecial,
  LoadingConfig,
};
